const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "TBM 실시일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "TBM 실시일", "폭염작업여부", "상태"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.TBM정보.TBM실시일", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.TBM정보.TBM실시일", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "작업명",
        key: "body.TBM정보.작업명",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "TBM 실시일",
        key: "body.TBM정보.TBM실시일",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "폭염작업여부",
        key: "body.TBM정보.폭염작업여부",
      },
      {
        name: "상태",
        key: "",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 6) {
          const 폭염작업여부 = func.getContent(value).TBM정보.폭염작업여부;
          if (폭염작업여부) {
            return 폭염작업여부;
          } else {
            return "N";
          }
        } else if (index === 7) {
          const body = func.getContent(value);
          const 참석자명단 = body.참석자명단;
          const 사진대지 = body.photoList.filter((e) => e.id);
          const TBM실시시간 = body.TBM정보.TBM실시시간;

          if (참석자명단.length === 0 || 사진대지.length === 0 || !TBM실시시간.eTime) {
            return { type: "html", html: `<span style="color:#EA5455">미진행</span>`, color: "#EA5455", text: "미진행" };
          } else {
            return { type: "html", html: `<span style="color:#28C76F">완료</span>`, color: "#28C76F", text: "완료" };
          }
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
